import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list'; 
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { TopClickNavComponent } from './top-click-nav/top-click-nav.component';
import { TopSecondaryNavComponent } from './top-secondary-nav/top-secondary-nav.component';
import { MatSideNavComponent } from './mat-side-nav/mat-side-nav.component';
import { MouAckComponent } from './mou-ack/mou-ack.component';

@NgModule({
	declarations: [
		TopClickNavComponent
		, TopSecondaryNavComponent
		, MatSideNavComponent
		, MouAckComponent
	],
	imports: [
		RouterModule
		, CommonModule
		, FormsModule
		, MatTabsModule
		, MatListModule
		, FontAwesomeModule
	],
	exports: [
		TopClickNavComponent
		, TopSecondaryNavComponent
		, MatTabsModule 
		, MatListModule
		, FontAwesomeModule
		, MatSideNavComponent
		, MouAckComponent
	]
})
export class NavigationModule {}
